export default __webpack_public_path__ + "static/media/logo.acbcd318.png";